"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSynonyms = exports.withSynonymsSyncStatus = exports.getOrCreateSynonymsGroupByName = void 0;
const client_1 = require("../../_generated/client");
const helpers_1 = require("../helpers");
/**
 * Function creates or retrieves list of index models. These models later on are used for retrieving synonyms from dashboard client
 * @param dashboardConfig - KeyCloak configuration function
 * @param internalGroupId - Dashboard client group id
 * @param synonymsGroupName - Synonym Group Index Name (PS: Use nice format like "Senukai LT Variation 1") This name will be visible in dashboard client frontend
 */
async function getOrCreateSynonymsGroupByName(access, internalGroupId, synonymsGroupName) {
    const getSynonymsIndexes = async () => new client_1.SynonymsApi(await access()).getSynonymsIndexes(internalGroupId);
    const indexList = await getSynonymsIndexes();
    const synonymsGroup = indexList.data.find((c) => c.resource.name === synonymsGroupName);
    if (synonymsGroup) {
        return synonymsGroup;
    }
    const createSynonymsIndex = async () => new client_1.SynonymsApi(await access()).createSynonymsIndex(internalGroupId, {
        name: synonymsGroupName
    });
    const result = await createSynonymsIndex();
    return result.data;
}
exports.getOrCreateSynonymsGroupByName = getOrCreateSynonymsGroupByName;
/**
 * Function updates sync status in dashboard
 * @param configuration - Dashboard access function {@link DashboardAccess}
 * @param synonymsConfig - Basic data
 * @param fn - Execute function
 */
async function withSynonymsSyncStatus(configuration, synonymsConfig, fn) {
    const { internalGroupName, synonymsGroupName } = synonymsConfig;
    const groupModel = await helpers_1.getOrCreateGroupByName(configuration, internalGroupName);
    const synonymsGroup = await getOrCreateSynonymsGroupByName(configuration, groupModel.id, synonymsGroupName);
    await new client_1.SynonymsApi(await configuration()).updateSynonymsIndexLastSyncStart(groupModel.id, synonymsGroup.id);
    return fn().finally(async () => {
        await new client_1.SynonymsApi(await configuration()).updateSynonymsIndexLastSyncEnd(groupModel.id, synonymsGroup.id);
    });
}
exports.withSynonymsSyncStatus = withSynonymsSyncStatus;
/**
 * Function will get all synonyms from dashaboard
 * @param configuration - Dashboard access function
 * @param synonymsConfig - Basic data
 */
async function getSynonyms(configuration, synonymsConfig) {
    const { internalGroupName, synonymsGroupName } = synonymsConfig;
    const groupModel = await helpers_1.getOrCreateGroupByName(configuration, internalGroupName);
    const synonymsGroup = await getOrCreateSynonymsGroupByName(configuration, groupModel.id, synonymsGroupName);
    const connectedListsCache = new Map();
    const lists = await new client_1.SynonymsApi(await configuration()).getSynonymsLists(groupModel.id, [synonymsGroup.id]);
    /**
     * Removing list that do not belong to index
     */
    const normalizedLists = [synonymsGroup].map((indexItem) => {
        return {
            indexItem,
            connectedLists: lists.data.filter((list) => list.resource.indexIds.includes(indexItem.id)),
        };
    });
    const synonyms = new Set();
    for await (const { connectedLists, indexItem } of normalizedLists) {
        const getSynonymsIndexItems = async () => (new client_1.SynonymsApi(await configuration()).getSynonymsIndexItems(groupModel.id, indexItem.id));
        const getSynonymsListItems = async (synonymsListModelId) => (new client_1.SynonymsApi(await configuration()).getSynonymsListItems(groupModel.id, synonymsListModelId));
        const getListItems = async (synonymsListModelId) => {
            const items = connectedListsCache.get(synonymsListModelId);
            if (items) {
                return items;
            }
            const res = await getSynonymsListItems(synonymsListModelId);
            return res.data;
        };
        const indexItems = await getSynonymsIndexItems();
        for (const synonym of indexItems.data) {
            synonyms.add(synonym.resource.synonym);
        }
        for await (const list of connectedLists) {
            const xItems = await getListItems(list.id);
            for (const synonym of xItems) {
                synonyms.add(synonym.resource.synonym);
            }
        }
    }
    return Array.from(synonyms.values());
}
exports.getSynonyms = getSynonyms;
